import apiClient from '@u/apiClient'

let base_errors = {}
export default {
  //region fetch
  async fetchBankList({ commit }) {
    await apiClient
      .get('api/fetch-bank-account')
      .then(async (response) => {
        await commit('setBanksList', response.data.bank_accounts)
        await commit('setBankMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchBankList', reason)
      })
  },
  async fetchBank({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get(`api/bank-account/${payload.id}`)
      .then(async (response) => {
        await commit('setBank', response.data.bank_account)
        await commit('setBankMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchBank', reason)
      })
  },
  async fetchNewBank({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get('api/model/new?model=BankAccount')
      .then(async (response) => {
        await commit('setBank', response.data.BankAccount)
        await commit('setBankMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchNewBank', reason)
      })
  },
  //endregion

  //region store
  storeBank(_, payload) {
    return apiClient
      .post('api/bank-account', payload.bank)
      .then(async (response) => {
        return response.data
      })
  },
  //endregion

  //region update
  updateBank(_, payload) {
    return apiClient
      .put(`api/bank-account/${payload.id}`, payload.bank)
      .then(async (response) => {
        return response.data
      })
  },
  //endregion

  //region delete
  deleteBankById({ commit }, payload) {
    return apiClient
      .delete(`api/bank-account/${payload.id}`)
      .then(async (response) => {
        await commit('setBanksList', response.data.bank_accounts)
        await commit('setBankMetadata', response.data.metadata)
        return response.data
      })
  },
  //endregion

  //region undoDelete
  undoDeleteBankById({ commit }, payload) {
    return apiClient
      .get(`api/bank-account/undo-delete/${payload.id}`)
      .then(async (response) => {
        await commit('setBanksList', response.data.bank_accounts)
        await commit('setBankMetadata', response.data.metadata)
        return response.data
      })
  }
  //endregion
}
